import { useSelector } from 'react-redux';
import { isCurrentUserProfileOwner } from '../selectors/users';

export default function useIsCurrentUserProfileOwner(): boolean {
  return useSelector(isCurrentUserProfileOwner);
}
